import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reportv2Tab, Reportv2TabList } from '../reportv2.const';
import { ReportService } from '../../../../../common/services/Report.service';
import { Observable } from 'rxjs/Rx';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { SearchService } from 'app/common/services/Search.service';
import { AssignType, getParams, ReportAgentConst } from './agent.const';
import { UserService } from '../../../../../common/services/User.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';
import { GroupService } from 'app/common/services/Group.service';
import { TicketService } from 'app/common/services/Ticket.service';
import { CampaignService } from 'app/common/services/Campaign.service';
import { Role } from '../../setting/expert/expert.const';
import { CommonSettingsService } from '../../../../../common/share-data/common.setting.service';
import { SharedUserService } from '../../../../../common/share-data/user.service';
declare var require: any;

const moment = require('moment');

declare var $: any;
@Component({
  selector: 'report-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.css', './ticket-search.module.css'],
  providers: [ReportService, SearchService, ExportCustomService, GroupService, TicketService, CampaignService],
})
export class AgentComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();

  @ViewChild('templateFilter') templateFilter: ElementRef;
  @Input()
  Type: string;

  @Input()
  goBackByType: any;

  @Input()
  dataOption: any;

  public dataSessionLeaveKeyLists: any = [
    { key: 'short', name: 'Short' },
    { key: 'long', name: 'Long' },
  ];
  public filterSearchKey = 'search_user';
  public filterHtml: any = {};
  public data_search: any = {};
  public is_updated = false;
  public data: any = [];
  public assignType = AssignType.All;
  public selectFilter: any = 'Bộ lọc mới';
  public tab = 'summary';

  public totalItem: any = 0;
  public totalPage: any = 0;
  public currentPage = 1;
  public page_size = 10;
  public loadDetailTicketKey = '';
  public displayFilter = false;
  public filterModal: any = {};

  public page_size_ticket = 10;
  public currentPageTicket = 1;
  public totalItemTicket = 1;
  public totalPageTicket: any = 0;
  public active_fields: any = [];

  public listToExportTicket: any = {};
  public isItemDetailActive: any = {};
  public dataDetailTicket: any = null;
  public displayColumns: any[] = [];
  public dataReceptionTop: any = [];
  public dataSummaryWorkingTime: any = [];
  public dataSummaryWorkingTimeView: any = [];
  public exportFields: any[] = [];
  private customParams: any = {};

  public dataReceptionDetail: any = null;
  public allUsers: any[] = [];
  public displayColumnsTicket: any[] = [];
  public modelFilter: any = {
    from_date: new Date(new Date().setDate(new Date().getDate() - 7)),
    to_date: new Date(),
    amount: 5,
    group_id_receive: 'all',
    group_id_agent_working: 'all',
  };
  public autoSubmitOnInit: boolean = false;
  public exportType = {
    ReceptionTop: 'ReceptionTop',
  };

  public groupUser: any[] = [];

  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;
  private _filterChecked: any = null;

  public get filterChecked() {
    return this._filterChecked ? this._filterChecked._id : null;
  }
  public isLoading = false;
  public set filterChecked(value) {
    this._filterChecked = this.filterChecked === value._id ? null : value;
    this.choiceFilter(this._filterChecked);
  }

  public teamLeader = Role.TeamLeader;
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private searchService: SearchService,
    private userService: UserService,
    private socketService: SocketService,
    private exportCustomService: ExportCustomService,
    private ticketService: TicketService,
    private campaignService: CampaignService,
    private sharedCommonSettings: CommonSettingsService,
    private sharedUserService: SharedUserService
  ) {
    super(changeDetector, toastr, modalService);
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  async ngOnInit() {
    this.model = {
      sub_and_or: 'and',
      main_and_or: 'and',
      active_fields: [],
      data_save: {},
      data_search: {},
    };
    this.is_loading = true;
    this.displayColumns = ReportAgentConst.displayColumns();
    this.displayColumnsTicket = ReportAgentConst.displayColumnsTicket();
    await this.loadAllUsers();
    const group = await this.sharedUserService.getUserGroups();
    this.groupUser = [{ value: 'all', label: 'Tất cả' }, ...group.map(a => ({ value: a.id, label: a.name }))];
    this.loadData();
  }
  async loadAllUsers() {
    const res = await this.sharedUserService.getAllUsers();
    const agentList = [];
    res.forEach((c: any) => {
      agentList.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allUsers = agentList;
  }

  loadData(): void {
    this.isLoading = true;
    if (this.dataOption && this.dataOption.group) {
      this.modelFilter.group_id_receive = this.dataOption.group.id;
      this.modelFilter.group_id_agent_working = this.dataOption.group.id;
      this.modelFilter.from_date = this.dataOption.payload.from_date;
      this.modelFilter.to_date = this.dataOption.payload.to_date;
    }
    let payload: any = {
      from_date: moment(this.modelFilter.from_date).format('YYYY-MM-DD'),
      to_date: moment(this.modelFilter.to_date).add(1, 'days').format('YYYY-MM-DD'),
      amount: Number(this.modelFilter.amount) || 5,
    };

    if (this.modelFilter.group_id_agent_working != 'all') {
      payload.group_id_agent_working = Number(this.modelFilter.group_id_agent_working);
    }

    if (this.modelFilter.group_id_receive != 'all') {
      payload.group_id_receive = Number(this.modelFilter.group_id_receive);
    }

    if (this.user.role == Role.TeamLeader && this.Type !== 'group') {
      payload.group_id_agent_working = this.user.group_id;
      payload.group_id_receive = this.user.group_id;
      this.modelFilter.group_id_agent_working = this.user.group_id;
      this.modelFilter.group_id_receive = this.user.group_id;
    }

    this.reportService.agentv2(payload).subscribe(res => {
      this.dataSummaryWorkingTime = res.data[0];
      this.totalItem = this.dataSummaryWorkingTime.length;
      this.totalPage = Math.ceil(this.totalItem / this.page_size);
      this.paginationData();
      this.dataReceptionTop = res.data[1];
      let total = 0;
      this.dataReceptionTop.map(value => (total += value.count));
      this.dataReceptionTop = this.dataReceptionTop.map(value => {
        value.percent = Number(((value.count / this.dataReceptionTop[0].count) * 100).toFixed(2));
        return value;
      });
      this.isLoading = false;
    });
  }

  paginationData() {
    this.dataSummaryWorkingTimeView = this.dataSummaryWorkingTime.slice(
      (this.currentPage - 1) * this.page_size,
      this.currentPage * this.page_size
    );
  }

  setPage(page) {
    this.currentPage = page;
    this.paginationData();
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngAfterViewInit(): void {}

  onDateChange(key, value): void {
    this.loadData();
  }

  choiceFilter(data) {
    this.autoSubmitOnInit = false;
    this.selectFilter = 'Bộ lọc mới';
    this.filterHtml = { ...data };
    this.filterModal = {
      sub_and_or: 'and',
      main_and_or: 'and',
    };
  }

  async handleClickFieldContact(key, item) {
    this.dataDetailTicket = null;
    this.onShowDetailAgent(item);
  }

  onShowDetailAgent(item): void {
    this.isItemDetailActive = item;
    let payload = {
      from: this.modelFilter.from_date,
      to: this.modelFilter.to_date,
    };

    let assign_agent_id = this.allUsers.find(value => value.email == item.username);
    this.reportService.agentDetailv2(assign_agent_id._id, payload).subscribe(res => {
      this.dataReceptionDetail = {
        data: {
          source: res.data[0],
          status: res.data[1],
        },
        name: item.username,
      };
    });
  }

  goBack() {
    this.autoSubmitOnInit = false;
    this.dataReceptionDetail = null;
    this.displayFilter = false;
  }

  viewDetailsTicket(item, key) {
    this.loadDetailTicketKey = key;
    this.loadDetailTicket(item, false, key);
  }

  changedOptionView(data) {
    this.displayColumns = data;
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
  }

  changedOptionViewChild(data) {
    this.displayColumnsTicket = data;
  }

  async openTicket(ticket: any) {
    this.userService
      .find({ _id: ticket.requester_id })
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          ticket.request = res.data;
          this.socketService.opentab(ticket, 'ticket', 'edit');
        }
      });
  }

  loadDetailTicket(item, isExport = false, key) {
    let assign_agent_id = this.allUsers.find(value => value.email == this.isItemDetailActive.username);
    if (assign_agent_id) {
      const params = {
        source: 'all',
        limit: this.page_size_ticket,
        offset: this.page_size_ticket * (this.currentPageTicket <= 0 ? 0 : this.currentPageTicket - 1),
        sort_by: 'updated_at:desc',
      };

      let condition: any = {
        must: [
          {
            bool: {
              must: [{ match_phrase: { assign_agent_id: assign_agent_id._id } }],
            },
          },
        ],
      };

      if (key == 'source_detail') {
        condition.must.push({
          bool: {
            must: [{ match_phrase: { source_detail: item.key.toLowerCase() } }],
          },
        });
      }

      if (key == 'status') {
        condition.must.push({
          bool: {
            must: [{ match_phrase: { status: item.key } }],
          },
        });
      }

      condition.must.push({
        bool: {
          must: [
            {
              range: {
                created_at: {
                  gt: this.modelFilter.from_date.toISOString().split('T')[0],
                },
              },
            },
            {
              range: {
                created_at: {
                  lt: this.modelFilter.to_date.toISOString().split('T')[0],
                },
              },
            },
          ],
        },
      });

      const body = {
        condition: JSON.stringify(condition),
        active_fields: ['assign_agent_id', 'requester_id'],
        type: 'ticket',
        label: 'and',
        sub_label: 'and',
        keyword: '',
        force_search: 'customer',
        limit: this.page_size_ticket,
        offset: this.page_size_ticket * (this.currentPageTicket <= 0 ? 0 : this.currentPageTicket - 1),
      };

      this.searchService.list(params, body).subscribe(res => {
        if (res.status == 200 && !res.error) {
          if (!isExport) {
            this.dataDetailTicket = {
              data: res.data.res.list,
              item: item,
            };
            this.totalItemTicket = res.data.res.total;
            this.totalPageTicket = Math.ceil(this.totalItemTicket / this.page_size_ticket);
            this.dataDetailTicket.data = this.dataDetailTicket.data.map(e => {
              e.display_code = ReportAgentConst.displayCodeColumns(e);
              e.display_requester = ReportAgentConst.displayRequesterColumns(e.request, this.user);
              e.display_subject = ReportAgentConst.displaySubjectColumns(e, this.user);
              e.display_assignee = ReportAgentConst.displayAssigneeColumns(e, this.allUsers);
              e.display_source = ReportAgentConst.displaySourceColumns(e);
              e.display_status = ReportAgentConst.displayStatusColumns(e);
              e.display_created_at = ReportAgentConst.displayTimeColumns(e.created_at);
              e.display_updated_at = ReportAgentConst.displayTimeColumns(e.updated_at);
              return e;
            });
          } else {
            this.listToExportTicket = {
              data: res.data.res.list,
              item: item,
            };

            this.listToExportTicket.data = this.listToExportTicket.data.map(e => {
              e.display_code = ReportAgentConst.displayCodeColumns(e);
              e.display_requester = ReportAgentConst.displayRequesterColumns(e.request, this.user);
              e.display_subject = ReportAgentConst.displaySubjectColumns(e, this.user);
              e.display_assignee = ReportAgentConst.displayAssigneeColumns(e, this.allUsers);
              e.display_source = ReportAgentConst.displaySourceColumns(e);
              e.display_status = ReportAgentConst.displayStatusColumns(e);
              e.display_created_at = ReportAgentConst.displayTimeColumns(e.created_at);
              e.display_updated_at = ReportAgentConst.displayTimeColumns(e.updated_at);
              return e;
            });
          }
        } else {
          this.dataDetailTicket = {
            data: [],
            item: item,
          };
        }
      });
    }
    this.model = {
      sub_and_or: 'and',
      main_and_or: 'and',
    };
  }

  setPageTicket(page) {
    this.currentPageTicket = page;
    this.loadDetailTicket(this.dataDetailTicket.item, false, this.loadDetailTicketKey);
  }

  exportExcelTicketDetail(item, key) {
    let assign_agent_id = this.allUsers.find(value => value.email == this.isItemDetailActive.username);

    const condition: any = {
      must: [
        {
          bool: {
            must: [{ match_phrase: { assign_agent_id: assign_agent_id._id } }],
          },
        },

        {
          bool: {
            must: [
              {
                match_phrase: {
                  [key]: key == 'source_detail' ? item.key.toLowerCase() : item.key,
                },
              },
            ],
          },
        },

        {
          bool: {
            must: [
              {
                range: {
                  created_at: {
                    gt: new Date(this.modelFilter.from_date),
                  },
                },
              },
              {
                range: {
                  created_at: {
                    lt: new Date(this.modelFilter.to_date),
                  },
                },
              },
            ],
          },
        },
      ],
    };
    const params = {
      source: 'all',
    };
    const body = {
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(['assign_agent_id']),
      type: 'ticket',
      label: 'and',
      sub_label: 'and',
      keyword: '',
      force_search: 'customer',
    };
    this.ticketService.exports(params, body);
  }

  export(type): void {
    console.log(type, 'item');
    let exportDatas: any = {
      data: [],
    };
    let data: any = {};
    let title = '';
    switch (type) {
      case this.exportType.ReceptionTop:
        this.dataReceptionTop.map((value, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Chuyên viên'] = value.name;
          data_json['Số lượng'] = value.count;
          exportDatas.data.push(data_json);
        });
        data['title'] = 'Thống kê Top chuyên viên tiếp nhận cao';
        data['column'] = ['STT', 'Chuyên viên', 'Số lượng'];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment(this.modelFilter.from_date).format('YYYY-MM-DD')} - Đến ngày: ${moment(this.modelFilter.to_date).format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 40, 24];
        title = 'Thống kê Top chuyên viên tiếp nhận cao';
        break;
      default:
        break;
    }

    this.exportCustomService.exportExcelCustom(
      exportDatas.data,
      title + ' ' + moment(new Date()).format('YYYY-MM-DD HH-mm'),
      data // Adding a default sheet name as the third argument
    );
  }

  onGroupChange() {
    this.loadData();
  }
  s;
  toggleFilter() {
    this.autoSubmitOnInit = false;
    this.displayFilter = !this.displayFilter;
    let assign_agent_id = this.allUsers.find(value => value.email == this.isItemDetailActive.username);
    this.selectFilter = 'Bộ lọc mới';
    const data = {
      assign_agent_id: [
        {
          label: 'eq',
          val: assign_agent_id._id,
        },
      ],
      created_at: [
        {
          label: 'gt',
          val: this.modelFilter.from_date.toISOString().split('T')[0],
        },
        {
          label: 'lt',
          val: moment(this.modelFilter.to_date).add(1, 'day').toISOString().split('T')[0],
        },
      ],
    };
    this.choiceFilter(data);
  }
  endLoading() {
    this.is_loading = false;
  }

  async buildPayload(customField = {}) {
    const data = this.data_search;
    let active_fields = this.active_fields;
    let condition = {};
    const arr = [];
    active_fields = _.union(active_fields);
    active_fields.forEach(field => {
      const sub_condition = {};
      if (this.model.sub_and_or == 'and') {
        sub_condition['must'] = data[field];
      } else {
        sub_condition['should'] = data[field];
      }
      arr.push({
        bool: sub_condition,
      });
    });
    if (arr.length > 0) {
      if (this.model.main_and_or == 'and') {
        condition['must'] = arr;
      } else {
        condition['should'] = arr;
      }
    } else {
      condition = {};
    }
    const fill = [];
    let inputParameters = {};
    if (this.modelFilter['source'] && this.modelFilter['source'] != 'all') {
      fill.push({
        key: 'source_detail',
        condition: '=',
        value: this.modelFilter['source'],
      });
    }
    const body = {
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(active_fields),
      type: 'ticket',
      label: this.model.main_and_or,
      sub_label: this.model.sub_and_or,
      keyword: this.model.keyword ? this.model.keyword.trim() : '',
      force_search: 'customer',
      ...customField,
    };
    // update filter
    const params = {
      filter: '',
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      limit: this.page_size,
      sort_by: 'updated_at:desc',
      source: getParams(this.assignType),
      ...this.customParams,
    };
    if (this.model.keyword) {
      fill.push({
        key: 'subject',
        condition: '=',
        value: this.model.keyword ? this.model.keyword.trim() : '',
      });
    }
    switch (this.assignType) {
      case AssignType.MissedCall:
        fill.push({ key: 'call_status', condition: '=', value: 'miss' });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.NotTag:
        fill.push(
          { key: 'assign_agent_id', condition: '=', value: null },
          { key: 'status', condition: 'nin', value: [] }
        );
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.Open:
        fill.push({ key: 'status', condition: 'in', value: [1, 2, 4] });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.InProcess:
        fill.push({ key: 'status', condition: '=', value: 2 });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.Completed:
        fill.push({ key: 'status', condition: '=', value: 5 });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.Campaign:
        break;
      case AssignType.NearExpired:
        const date1 = new Date();
        date1.setDate(date1.getDate() + 1);
        fill.push(
          {
            key: 'duedate',
            condition: 'lt',
            value: moment(date1).format('YYYY-MM-DD') + 'T23:59:59.999Z',
          },
          {
            key: 'duedate',
            condition: 'gt',
            value: moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
          },
          { key: 'status', condition: 'in', value: [1, 2, 4] }
        );
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      default:
        if (this.modelFilter && this.modelFilter['source'] && this.modelFilter['source'] != 'all') {
          active_fields = ['source_detail'];
          condition['must'] = [
            {
              bool: {
                must: [
                  {
                    match: {
                      source_detail: this.modelFilter['source'],
                    },
                  },
                ],
              },
            },
          ];
          body['active_fields'] = JSON.stringify(active_fields);
          body['condition'] = JSON.stringify(condition);
          inputParameters = params;
        }
        break;
    }
    if (this.assignType == AssignType.Campaign) {
      await this.campaignService.all().subscribe(async res => {
        if (res.status == 200 && !res.error) {
          const campaigns = res.data.list.map(c => c._id);
          fill.push({ key: 'campaign_id', condition: 'in', value: campaigns });
        }
        fill.push(
          { key: 'assign_agent_id', condition: '=', value: this.user._id },
          { key: 'status', condition: 'nin', value: [] }
        );
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        return [body, inputParameters];
      });
    } else {
      params.filter = JSON.stringify(fill);
      inputParameters = params;
      return [body, inputParameters];
    }
  }

  async fetchData(body, inputParameters) {
    const params = {
      source: 'all',
      sort_by: 'updated_at:desc',
    };
    this.ticketService.exports(params, body);
  }

  async loadDataSearch(isSearch = false, customField = {}) {
    this.is_updated = false;
    this.data = [];
    if (isSearch) {
      this.currentPage = 1;
    }
    const [body, inputParameters] = await this.buildPayload(customField);
    await this.fetchData(body, inputParameters);
  }

  loadDataByFilter(data) {
    if (this.autoSubmitOnInit) {
      this.model.main_and_or = data.main_and_or || 'and';
      this.model.sub_and_or = data.sub_and_or || 'and';
      this.data_search = data.data_search || {};
      this.active_fields = data.active_fields || [];
      console.log(this.filterModal, 'this.filterModal');
      console.log(this.filterSearchKey, 'this.filterSearchKey');
      console.log(this.model, 'this.model');
      this.loadDataSearch(true);
    }
    this.autoSubmitOnInit = true;
  }
  onTabChange(tab) {
    this.tab = tab;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/agent/agent.component.ts